import { reinitSlider } from "./ui.js";

export function initEditor() {
  const cache = new Map(); // To store the current state of variables

  function updateDynamicTags(variableKey, variableValue) {
    const elements = document.querySelectorAll(
      `[data-mossy-preview=${variableKey}]`,
    );
    if (!elements.length) return;

    if (Array.isArray(variableValue)) {
      const firstElement = elements[0];

      // Walk up from the preview element to find the repeating unit:
      // the highest ancestor whose parent contains other [data-mossy-preview] siblings
      let templateNode = firstElement;
      while (templateNode.parentElement) {
        const parent = templateNode.parentElement;
        const siblings = parent.querySelectorAll(
          `[data-mossy-preview=${variableKey}]`,
        );
        if (siblings.length > 1) {
          // Parent contains multiple preview elements — templateNode is the repeating unit
          break;
        }
        templateNode = parent;
      }

      const container = templateNode.parentElement;

      // Remove all current repeating units
      Array.from(container.children)
        .filter(
          (el) =>
            el.querySelector(`[data-mossy-preview=${variableKey}]`) ||
            el.matches(`[data-mossy-preview=${variableKey}]`),
        )
        .forEach((el) => el.remove());

      // Rebuild one unit per item
      // Rebuild one unit per item
      variableValue.forEach((item) => {
        const clone = templateNode.cloneNode(true);
        const previewEl = clone.matches(`[data-mossy-preview=${variableKey}]`)
          ? clone
          : clone.querySelector(`[data-mossy-preview=${variableKey}]`);

        if (previewEl) {
          const previewKey = previewEl.getAttribute("data-mossy-preview-key");
          const value = item?.src || item;
          if (previewKey) {
            previewEl.setAttribute(previewKey, value);
          } else {
            previewEl.textContent = value;
          }
        }
        container.appendChild(clone);
      });

      // Re-init slider if the container is inside one
      const sliderRoot = container.closest("[data-mossy-slider]");
      if (sliderRoot) reinitSlider(sliderRoot);
    } else {
      elements.forEach((element) => {
        const previewKey = element.getAttribute("data-mossy-preview-key");
        if (previewKey) {
          if (element.getAttribute(previewKey) !== variableValue) {
            element.setAttribute(previewKey, variableValue);
          }
        } else {
          element.textContent = variableValue;
        }
      });
    }
  }

  function handleVariableUpdate(data) {
    const { key, value } = data.variable;

    // Update CSS vars only on message events
    if (!cache.has(key) || cache.get(key) !== value) {
      document.documentElement.style.setProperty(`--mossy-${key}`, value);
      cache.set(key, value);
    }

    // Update dynamic tags
    console.log("check", key, value);
    updateDynamicTags(key, value);
  }

  function handleNavigation() {
    cache.forEach((value, key) => {
      // Temp solution to persist preview changes
      setTimeout(() => {
        updateDynamicTags(key, value);
      }, "200");
    });
  }

  // Listen for messages to update state and CSS vars
  window.addEventListener("message", (event) => {
    console.log("Message received.", event.data);
    if (event.data && event.data.variable) {
      handleVariableUpdate(event.data);
    }
  });

  document.addEventListener("mossy-router", handleNavigation);
}
